// extracted by mini-css-extract-plugin
module.exports = {"ReceivedInformationModalGrayText":"ReceivedInformation_ReceivedInformationModalGrayText__387f9","imageCircle":"ReceivedInformation_imageCircle__2mUfF"};